// types.d.ts

// Define the main Registry type
export interface Registry {
  id: number
  is_header: number
  category: number
  ordering: number
  code: string
  code_type: CodeType
  createdAt: string
  modifiedAt: string
  status: number
  translations: RegistryTranslation[]
}

//
// Define an interface for objects that have translations
export interface HasTranslations {
  translations: Array<{
    language_id: number
    [key: string]: any // Allow any other properties
  }>
}

export enum CodeType {
  INT = 'INT',
  TEXT = 'TEXT',
  FLOAT = 'FLOAT',
  JSON = 'JSON'
}

//
export enum EditorTask {
  Show = 'show',
  NewCategory = 'new category',
  EditCategory = 'edit category',
  NewRegistry = 'new registry',
  EditRegistry = 'edit registry',
  NewTranslation = 'new translation',
  EditTranslation = 'edit translation',
  CopyTranslation = 'copy translation',
  NewWord = 'new word',
  NewTopic = 'new topic',
  EditTopic = 'edit topic'
}

// Define the RegistryTranslation type for multilingual support
export interface RegistryTranslation {
  id: number
  registry_id: number
  language_id: number
  is_active: number
  editor_id: number
  code_value: string
  comment: string
  createdAt: string
  modifiedAt: string
  mark: number
  status: number
}

//
// export interface EditBuffer {
//   registry: Registry // Registry object
//   category: number // category id
//   is_header: number
//   ordering: number //
//   code: string
//   code_type: code_type
//   status: number
//   translation: RegistryTranslation // RegistryTranslation object
//   code_value: string
//   comment: string
// }

//
export interface RegistryEditBuffer {
  category: number
  is_header: number
  ordering: number
  code_type: CodeType
  code: string
  status: number
  language_id: number
  code_value: string
  comment: string
  is_active: number
}

//
export interface RegistryEditor extends Registry {
  // the translation object that currently the editor is editing
  currentTranslation: RegistryTranslation
  original: Registry | Record<string, never>
}

// Category hold an array of Registry as its items sharing the same categoryId
// only category headers will be downloaded to form the category selection options
// when a category is selected
// items will be downloaded
export interface Category {
  header: Registry
  items: Registry[]
}

//
export type UpdateRegistryInputType = {
  id: number
  category: number
  is_header: number
  ordering: number
  code_type: CodeType
  code: string
  status: number
  translations: [
    {
      id: number
      language_id: number
      code_value: string
      comment: string
      status: number
    }
  ]
}

//
export type ActivateRegistryTranslationInputType = {
  id: number
  registry_id: number
  language_id: number
}
